module.exports = __webpack_public_path__ + "img/slide3.fb17fef0.png";